import React from 'react';
import PropTypes from 'prop-types';

export default function Card({children, title, className, ...props}) {
  return (
    <div className={`dashboard-card ${className ? className : ''}`} {...props}>
      <div className="dashboard-card-title"> {title }</div>
      <div className="dashboard-card-body">
        {children}
      </div>
    </div>)
}

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  className: PropTypes.string
}